import React, { Component } from 'react';
import styles from './RegimenFinder.module.sass';
import SkinType from '../skin_type/SkinType';
import Step from '../../../quiz/components/step/Step';
import Banner from '../banner/Banner';
import SkinConcerns from '../skin_concerns/SkinConcerns';
// import RegimenProducts from '../regimen_products/RegimenProducts';
import api from '../../api';
import RegimenResult from '../regimen_result/RegimenResult';
import ga4DataLayer from '../../../services/ga4_datalayer';

const defaultRegimen = {
  step: 1,
  skinType: null,
  isSensitiveSkin: null,
  concerns: [],
  selectedProductIds: [],
};

const REGIMEN_FINDER_URLS = [
  '/regimen_finder/',
  '/regimen_finder/skin_type/',
  '/regimen_finder/skin_concerns/',
  '/regimen_finder/result/',
];

const QUIZ_ID = 'regimen_finder';

// step_id derivation per quiz step, keyed by the step the user is leaving.
// Results (step 3) has no entry here — its completion is tracked as
// quiz_complete from RegimenResult instead.
// Only the step's identity is tracked — never the answers (skin type,
// sensitivity, concerns), which could read as consumer health data under
// Washington's My Health My Data Act.
const stepCompletionMeta = (regimen) => ({
  1: { stepId: 'skin_type' },
  2: { stepId: 'skin_concerns' },
}[regimen.step]);

class RegimenFinder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regimen: defaultRegimen,
      loading: false,
      allProducts: [],
      skincareProducts: {},
      productsTaggings: {},
      boughtProductIds: null,
      email: null,
    };
  }

  componentDidMount() {
    // this.loadBoughtProductIds();
    this.setState({
      boughtProductIds: [],
    });
    this.loadSkincareProducts();
    this.loadAllProducts();
    this.loadProductsTaggings();

    const { regimen } = this.state;

    window.history.replaceState({ step: 1 }, '', REGIMEN_FINDER_URLS[1]);
    for (let i = 2; i <= regimen.step; i += 1) {
      window.history.pushState({ step: i }, '', REGIMEN_FINDER_URLS[i]);
    }

    window.onpopstate = (event) => {
      if (!event.state) { return; }

      this.goToStep(event.state.step);
    };

    window.ju_callback = (t, submittedEmail) => {
      this.setState({ email: submittedEmail });
    };

    ga4DataLayer.trackQuizStart({
      quizId: QUIZ_ID,
      entryPath: REGIMEN_FINDER_URLS[1],
    });
  }

  goToStep = (step) => {
    const { regimen } = this.state;
    const newRegimen = { ...regimen, step };
    this.setState({ regimen: newRegimen });
  };

  loadAllProducts = () => {
    api.loadAllProducts().then((response) => {
      this.setState({
        allProducts: response.data,
      });
    });
  };

  loadSkincareProducts = () => {
    api.loadSkincareProducts().then((response) => {
      this.setState({
        skincareProducts: response.data,
      });
    });
  };

  // loadBoughtProductIds = () => {
  //   api.loadBoughtProductIds().then((response) => {
  //     this.setState({
  //       boughtProductIds: response.data,
  //     });
  //   });
  // };

  loadProductsTaggings = () => {
    api.loadProductsTaggings().then((response) => {
      this.setState({
        productsTaggings: response.data,
      });
    });
  };

  increaseStep = (updatedRegimen) => {
    const { loading } = this.state;
    if (loading) { return; }

    const meta = stepCompletionMeta(updatedRegimen);
    if (meta) {
      ga4DataLayer.trackQuizStepComplete({
        quizId: QUIZ_ID,
        stepId: meta.stepId,
        stepNumber: updatedRegimen.step,
      });
    }

    const newRegimen = { ...updatedRegimen, step: updatedRegimen.step + 1 };
    this.setState({ regimen: newRegimen });
    window.history.pushState({ step: newRegimen.step }, '', REGIMEN_FINDER_URLS[newRegimen.step]);
  };

  decreaseStep = (updatedRegimen) => {
    const { loading } = this.state;
    if (loading) { return; }

    const newRegimen = { ...updatedRegimen, step: updatedRegimen.step - 1 };
    this.setState({ regimen: newRegimen });
    window.history.back();
  };

  render() {
    const {
      regimen, allProducts, skincareProducts, productsTaggings, boughtProductIds, email,
    } = this.state;

    const step = (
      <Step
        currentStep={regimen.step}
        totalSteps={3}
        color="#CFDEB7"
      />
    );

    return (
      <div className={styles['regimen-finder']}>
        { regimen.step > 0 && (
          <Banner />
        )}
        { regimen.step === 1 && (
          <SkinType
            regimen={regimen}
            increaseStep={this.increaseStep}
            decreaseStep={this.decreaseStep}
            step={step}
          />
        )}
        { regimen.step === 2 && (
          <SkinConcerns
            regimen={regimen}
            increaseStep={this.increaseStep}
            decreaseStep={this.decreaseStep}
            step={step}
            skincareProducts={skincareProducts}
            boughtProductIds={boughtProductIds}
            allProducts={allProducts}
            productsTaggings={productsTaggings}
          />
        )}
        {/* { regimen.step === 3 && (
          <RegimenProducts
            regimen={regimen}
            increaseStep={this.increaseStep}
            decreaseStep={this.decreaseStep}
            step={step}
            skincareProducts={skincareProducts}
            allProducts={allProducts}
            productsTaggings={productsTaggings}
            boughtProductIds={boughtProductIds}
          />
        )} */}
        { regimen.step === 3 && (
          <RegimenResult
            regimen={regimen}
            increaseStep={this.increaseStep}
            decreaseStep={this.decreaseStep}
            step={step}
            allProducts={allProducts}
            productsTaggings={productsTaggings}
            email={email}
          />
        )}
      </div>
    );
  }
}

export default RegimenFinder;
